// Stub file - costs functionality removed (was using Supabase)
// All cost data should come from backend API endpoints

export function useCosts() {
  return {
    costos: [],
    loading: false,
    error: null,
    refetch: () => {},
    createCost: async () => { throw new Error('Not implemented - use backend API') },
    updateCost: async () => { throw new Error('Not implemented - use backend API') },
    deleteCost: async () => { throw new Error('Not implemented - use backend API') },
  };
}